import React from 'react';
import styled from 'styled-components';

import QoverHorizontalIcon from './icons/QoverHorizontalIcon';

const Container = styled.div`
  color: ${({ theme }) => theme.colors.textQuote()};
  display: flex;

  .qover-logo path {
    fill: ${({ theme }) => theme.colors.textQuote()};
  }

  svg {
    max-width: 150px;

    @media screen and (max-width: ${({ theme }) =>
        theme.breakpoints.maxWidth.M}) {
      max-width: 100px;
      width: 100%;
    }

    @media screen and (max-width: ${({ theme }) =>
        theme.breakpoints.maxWidth.S}) {
      margin-left: 5px;
      max-width: 80px;
    }

    @media screen and (max-width: ${({ theme }) =>
        theme.breakpoints.maxWidth.XS}) {
      height: 20px;
      max-width: 60px;
    }
  }
`;

export function QoverLogo() {
  return (
    <Container>
      <QoverHorizontalIcon />
    </Container>
  );
}
type PartnerLogoProps = {
  src: string;
};

export function PartnerLogo(props: PartnerLogoProps) {
  return (
    <Container>
      <img
        src={`https://assets.qover.me/css/${props.src}`}
        alt="Partner logo"
      />
    </Container>
  );
}
